<template>
  <div>
    <q-table
      :data="data"
      :columns="columns"
      row-key="id"
      :loading="loading"
      :pagination.sync="pagination"
      @row-click="rowClickHandler"
      binary-state-sort
    >
      <template v-slot:top>
        <span>Список зон</span>
        <q-space />
        <q-btn color="primary" :disable="loading" label="Новая зона" @click="addZone" />
        <div v-if="rowActive">
          <q-btn class="q-ml-sm" color="primary" :disable="loading" label="Показать на карте" @click="ShowZone" />
          <q-btn class="q-ml-sm" color="primary" :disable="loading" label="Удалить зону" @click="deleteZone" />
        </div>
        <q-space />
      </template>
      <template v-slot:header-cell-name="props">
        <q-th :props="props">
          Название
          <q-input borderless dense debounce="300" color="primary" v-model="filterName">
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </q-th>
      </template>
      <template v-slot:header-cell-description="props">
        <q-th :props="props">
          Описание
          <q-input borderless dense debounce="300" color="primary" v-model="filterDescription">
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </q-th>
      </template>
    </q-table>
    <confirm-dialog
      ref="confirmDialog"
      :open="confirm"
      @cancel="confirm = false"
    />
  </div>

</template>

<script>

import 'PageLocations/scss/main.scss'
import * as geoService from 'API/geoService'
import * as locationsService from 'API/locations'
import ConfirmDialog from 'Shared/ConfirmDialog'


export default {
  name: 'PageLocation',
  components: {
    ConfirmDialog
  },
  data () {
    return {
      currentZone: {},
      confirm: false,
      rowActive: false,
      filterName: "",
      filterDescription: "",
      loading: false,
      rowCount: 10,
      pagination: {
        sortBy: '',
        descending: false,
        rowsPerPage: 15,
      },
      columns: [
        {
          name: 'name',
          required: true,
          label: 'Название',
          align: 'left',
          field: 'name',
          sortable: false,
          classes: 'text-primary cursor-pointer',
          style: 'white-space: pre-wrap',
          headerStyle: 'font-weight: bold'
        },
        { name: 'description', align: 'left', label: 'Описание', field: 'description', sortable: false,  headerStyle: 'font-weight: bold' },
      ],
      data: [],
    }
  },
   mounted() {
    this.getZones()
  },
  methods: {
    async getZones() {
      const response = await geoService.getAreas()
      this.data = response.data.areas
    },
    rowClickHandler(e, row) {
      this.rowActive = true
      this.currentZone = row
    },
    ShowZone() {
      this.$router.push(`/region/${this.currentZone.id}`)
    },
    addZone() {
      this.$router.push('/map')
    },
    async deleteZone() {
      this.confirm = true
      this.$refs.confirmDialog.$once('answer', val => {
        if (val === 'confirm') this.removeZone()
        this.confirm = false
      })
    },
    async removeZone() {
      try {
        await locationsService.deleteArea(this.currentZone.id)
        await this.getZones()
      } catch (e) {
        console.error(e)
        throw e
      }
    },
  }


}
</script>

<style scoped>

</style>
